<template>
  <DialogFull :data="dialogSettings" @close="close">
    <template v-slot:dialog.body>
      <div class="container col-lg-8 col-sm-12">
        <h2 class="mt-5 pb-3">Create Interview Format Basic Details</h2>
        <InterviewFormatForm ref="interviewFormatForm" />
      </div>
    </template>
    <template v-slot:dialog.action>
      <PrimaryButton @click.native="handleSubmit" :loading="isLoading">
        Create New
      </PrimaryButton>
    </template>
  </DialogFull>
</template>

<script>
import DialogFull from "@/components/common/DialogFull";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { INTERVIEWS_NAMESPACE } from "@/store/modules/bookings/interviews";
import {
  ADD_INTERVIEW_FORMAT,
  FETCH_BOOKING_INTERVIEW_FORMATS
} from "@/store/modules/bookings/interviews/actions";
import { createNamespacedHelpers } from "vuex";
import InterviewFormatForm from "@/views/bookings/BookingInterviews/components/InterviewFormatForm";

const { mapActions: mapInterviewActions } = createNamespacedHelpers(
  INTERVIEWS_NAMESPACE
);

export default {
  name: "AddInterviewFormatDialog",
  props: {
    interviewFormat: Object,
    isOpen: Boolean
  },
  components: {
    PrimaryButton,
    DialogFull,
    InterviewFormatForm
  },
  data() {
    return {
      isLoading: false
    };
  },
  computed: {
    dialogSettings() {
      return {
        dialog: this.isOpen,
        title: "Basic Details"
      };
    },
    currentBookingId() {
      return this.$route.params.id;
    },
    interviewFormatData() {
      const {
        interviewerDetails,
        candidateDetails,
        interviewName,
        duration
      } = this.$refs.interviewFormatForm.interviewFormatData;

      return {
        interviewerDetails,
        candidateDetails,
        interviewName,
        duration,
        booking: {
          id: this.currentBookingId
        }
      };
    }
  },
  methods: {
    ...mapInterviewActions({
      fetchInterviewFormats: FETCH_BOOKING_INTERVIEW_FORMATS,
      addInterviewFormat: ADD_INTERVIEW_FORMAT
    }),
    async handleSubmit() {
      const isValid = await this.$refs.interviewFormatForm.isFormValid();
      if (isValid) {
        this.isLoading = true;
        const { data: newInterviewFormat } = await this.addInterviewFormat(
          this.interviewFormatData
        );
        await this.$refs.interviewFormatForm.uploadFiles(newInterviewFormat.id);
        this.fetchInterviewFormats({
          bookingId: this.currentBookingId,
          withInclude: true
        });
        this.close();
        this.isLoading = false;
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style></style>
